import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-width": "1.5",
  "stroke-miterlimit": "10",
  d: "M7.1 1.1c-.2-.1-.5-.1-.7.1-.2.2-.2.5 0 .7L16.6 12 6.4 22.2c-.2.2-.2.5 0 .7.2.2.5.2.7 0 0 0 0 0 0 0l10.5-10.5c.2-.2.2-.5 0-.7L7.1 1.1z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-width": "1.5",
  "stroke-miterlimit": "10",
  d: "M6.7 23c-.3 0-.5-.2-.5-.5 0-.1.1-.2.1-.3L16.6 12 6.4 1.8c-.2-.2-.2-.5 0-.7.2-.1.5-.1.7 0l10.5 10.5c.2.2.2.5 0 .7L7.1 22.9c-.1 0-.2.1-.4.1z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }